/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const TasksIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    viewBox="0 0 34 34"
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" strokeLinejoin="round">
      <rect x="0.666666667" y="0.666666667" width="30.6666667" height="30.6666667" rx="2" />
      <polyline strokeLinecap="round" points="4.66666667 10 7.33333333 12.6666667 14 6" />
      <polyline strokeLinecap="round" points="4.66666667 22 7.33333333 24.6666667 14 18" />
      <path d="M16.6666667,11.3333333 L27.3333333,11.3333333" strokeLinecap="round" />
      <path d="M16.6666667,23.3333333 L27.3333333,23.3333333" strokeLinecap="round" />
    </g>
  </svg>
);

export default TasksIcon;
